import { createVanIconComponent } from "./van"

const LocationOutlined = createVanIconComponent("location-o")
export default LocationOutlined
